import { useEffect } from 'react';
export function useResizeObserver(ref, cb) {
    useEffect(() => {
        if (!ref.current)
            return;
        const ro = new ResizeObserver(cb);
        ro.observe(ref.current);
        return () => ro.disconnect();
    }, [ref, cb]);
}
//# sourceMappingURL=useResizeObserver.js.map